function Lightning({ fill, height = 21 }) {
  return (
    <svg height={height} viewBox="0 0 18 16">
      <title>Lightning</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-7.000000, -8.000000)"
          fill={fill || "currentColor"}
          fillRule="nonzero"
        >
          <g id="lightning" transform="translate(7.000000, 8.000000)">
            <path
              d="M17.5038365,0 L8.24383647,0 C7.54177657,-0.000595839984 6.88407611,0.34320213 6.48383647,0.920000775 L0.0338364656,10.1600008 C-0.00904151315,10.2300451 -0.0113179673,10.3176376 0.0278638034,10.3898145 C0.0670455741,10.4619915 0.1417397,10.5077999 0.223836466,10.5100008 L5.27383647,10.5100008 C5.35717105,10.509043 5.43389261,10.5552564 5.47200803,10.6293697 C5.51012345,10.703483 5.50308838,10.7927712 5.45383647,10.8600008 L2.16383647,15.5800008 C2.11184784,15.6712088 2.12821829,15.7860452 2.20362227,15.8590929 C2.27902624,15.9321405 2.39432445,15.944858 2.48383647,15.8900008 L15.8638365,6.51000078 C15.9387736,6.45069451 15.9692301,6.35122811 15.9403459,6.26013193 C15.9114618,6.16903574 15.8292556,6.10529163 15.7338365,6.10000078 L11.8638365,6.10000078 C11.7742277,6.09423588 11.6961674,6.03684929 11.6639333,5.95304046 C11.6316991,5.86923164 11.6511858,5.77432697 11.7138365,5.71000078 L17.6438365,0.390000775 C17.7156811,0.330985955 17.7426703,0.233178091 17.7112572,0.145670238 C17.6798442,0.0581623854 17.5968116,0 17.5038365,0 L17.5038365,0 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Lightning;
